import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>; // You could create a proper loading spinner component
  }

  if (!user) {
    // Redirect to login with the attempted path stored in state
    return (
      <Navigate
        to="/login"
        state={{
          from: location.pathname,
          message: "Session expired. Please log in."
        }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute; 